import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Flex,
  useColorModeValue,
  Image,
} from '@chakra-ui/react';

import processImage from '../assets/images/Process_image.webp';

const steps = [
  {
    number: '01',
    title: 'Análisis del requerimiento',
    description: 'Revisamos los términos de la licitación o necesidad del proyecto, analizando especificaciones técnicas, tiempos y condiciones de importación.',
  },
  {
    number: '02',
    title: 'Sourcing y cotización',
    description: 'Identificamos proveedores internacionales confiables y presentamos cotizaciones detalladas que cumplen con los requisitos del proceso.',
  },
  {
    number: '03',
    title: 'Gestión logística y aduanera',
    description: 'Coordinamos transporte internacional, documentación, nacionalización y seguimiento de la carga durante todo el trayecto.',
  },
  {
    number: '04',
    title: 'Entrega y cierre',
    description: 'Aseguramos la entrega del producto conforme a lo solicitado, con soporte documental y acompañamiento hasta el cierre del proyecto.',
  },
];

function ProcessSection() {
  const cardBg = useColorModeValue('rgba(255, 255, 255, 0.8)', 'rgba(15, 23, 42, 0.6)');
  const cardBorder = useColorModeValue('gray.200', 'whiteAlpha.200');
  const subtitleColor = useColorModeValue('gray.600', 'gray.300');
  const cardTextColor = useColorModeValue('gray.600', 'gray.400');
  const accentColor = useColorModeValue('brand.600', 'brand.300');

  return (
    <Box id="proceso" as="section" w="full">
      <Container maxW="1120px">
        <Flex
          direction={{ base: 'column', lg: 'row' }}
          gap={10}
          align="center"
        >
          {/* Text Content - 60% */}
          <VStack align="start" spacing={6} flex="0 0 60%" maxW={{ lg: '60%' }}>
            <Heading 
              as="h2" 
              fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
              fontWeight={900}
              >
              Somos tu mejor aliado en las licitaciones
            </Heading>
            <Text
              fontSize={{ base: 'lg', md: 'xl' }}
              color={subtitleColor}
              letterSpacing="wide"
              lineHeight="tall"
              pb={3}
              mb={2}
            >
              Te acompañamos de principio a fin, con documentación clara, cumplimiento normativo y entregables definidos en cada etapa.
            </Text>
            <VStack spacing={4} as="ol" listStyleType="none" w="full">
              {steps.map((step) => (
                <Flex
                  key={step.number}
                  as="li"
                  w="full"
                  gap={4}
                  align="flex-start"
                  bg={cardBg}
                  p={5}
                  borderRadius="xl"
                  border="1px solid"
                  borderColor={cardBorder}
                >
                  <Text fontWeight="900" color={accentColor} fontSize="lg">
                    {step.number}
                  </Text>
                  <Box>
                    <Heading as="h3" fontSize="lg" mb={1} fontWeight="900">
                      {step.title}
                    </Heading>
                    <Text color={cardTextColor} fontSize="sm">
                      {step.description}
                    </Text>
                  </Box>
                </Flex>
              ))}
            </VStack>
          </VStack>

          {/* Image - 40% */}
          <Box
            flex="0 0 40%"
            maxW={{ lg: '40%' }}
            w="full"
            h={{ base: '300px', lg: '400px' }}
            bg={cardBg}
            borderRadius="2xl"
            border="1px solid"
            borderColor={cardBorder}
            display="flex"
            alignItems="center"
            justifyContent="center"
            overflow="hidden"
          >
            {/* Placeholder - reemplazar con imagen */}
            <Image src={processImage} alt="About" objectFit="cover" w="full" h="full" loading="lazy" />
          </Box>
        </Flex>
      </Container>
    </Box>
  );
}

export default ProcessSection;
